// Central site config for X20 Consulting marketing site.
export const CONSULT_EMAIL = "hello@x20-consulting.com";

// mailto link used by every "Free Consultation" CTA. Pre-fills a subject so
// inbound requests are easy to triage before a booking flow exists.
export const CONSULT_MAILTO =
  `mailto:${CONSULT_EMAIL}` +
  "?subject=" +
  encodeURIComponent("Free consultation: X20 Consulting") +
  "&body=" +
  encodeURIComponent(
    "Hello X20 Consulting team,\n\nWe would like to book our free initial consultation.\n\n" +
      "What we are building, or the problem to solve:\n\n" +
      "Rough timeline:\n\n" +
      "Best way to reach us:\n",
  );

// Google Calendar booking page for the live demo: 30-minute slots on
// weekdays, Google Meet link sent on booking. Every "Book a demo" opens it.
export const DEMO_BOOKING_URL = "https://calendar.app.google/x2FmoaBwWPKg5tUn6";

// Unauthenticated track — shown to visitors (pairs with Login + Start Free).
export const PUBLIC_NAV_LINKS = [
  { name: "Capabilities", path: "/capabilities" },
  { name: "Feasibility Sprint", path: "/feasibility-sprint" },
  { name: "Platform", path: "/platform" },
  { name: "See It Live", path: "/live" },
  { name: "Proof", path: "/proof" },
  { name: "How We Work", path: "/how-we-work" },
  { name: "Built to Last", path: "/built-to-last" },
  { name: "About", path: "/about" },
];

// Authenticated track — shown once logged in (pairs with Logout).
// The Agent Composer (/agent-composer) is public now and sits in the main
// nav as "Agents". Marketing pages are also reachable when logged in. (No
// "Home" entry — per x20 convention, the top-left X20 Consulting logo
// returns to home.)
// The decisioning console, embedded at /live/monitor so its address never shows:
// public Caseflow monitor signed out; CRE and line-of-credit deal runs signed in
// (same Cognito pool as this site, signed in inside the frame).
export const LIVE_CONSOLE_URL = "https://console.x20-consulting.com";

export const OPERATOR_NAV_LINKS = [
  { name: "Engagement Scout", path: "/engagements" },
  { name: "Live monitor", path: "/live/monitor" },
];

export const AUTH_NAV_LINKS = [
  ...OPERATOR_NAV_LINKS,
  { name: "Capabilities", path: "/capabilities" },
  { name: "Feasibility Sprint", path: "/feasibility-sprint" },
  { name: "Platform", path: "/platform" },
  { name: "See It Live", path: "/live" },
  { name: "Proof", path: "/proof" },
  { name: "How We Work", path: "/how-we-work" },
  { name: "Built to Last", path: "/built-to-last" },
  { name: "About", path: "/about" },
];
